import { hashCodeLib } from 'shared';

export type ParsedDirection = {
  dep: string;
  arr: string;
  key: string;
};

export function parseDirectionFromSearchQuery(
  searchQuery: string,
): ParsedDirection | null {
  try {
    const searchParams = hashCodeLib.getSearchParams(searchQuery);
    return {
      dep: searchParams.dep,
      arr: searchParams.arr,
      key: `${searchParams.dep}-${searchParams.arr}`,
    };
  } catch {
    return null;
  }
}
